import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';

interface IDeclareItemPayload {
  title_item: string;
  declared_quantity: number;
  qualis_level?: string;
  scope?: string;
  selection_type?: string;
  observation?: string;
}

interface IUpdateItemPayload {
  declared_quantity?: number;
  qualis_level?: string;
  scope?: string;
  selection_type?: string;
  observation?: string;
}

const declareItem = async (submissionId: string, data: IDeclareItemPayload) => {
  const response = await configApi.post(`/api/title-submissions/${submissionId}/items/`, data);
  return response.data;
};

const updateItem = async (submissionId: string, itemId: string, data: IUpdateItemPayload) => {
  const response = await configApi.patch(`/api/title-submissions/${submissionId}/items/${itemId}/`, data);
  return response.data;
};

const deleteItem = async (submissionId: string, itemId: string) => {
  const response = await configApi.delete(`/api/title-submissions/${submissionId}/items/${itemId}/`);
  return response.data;
};

export const useDeclareTitleItem = (submissionId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: IDeclareItemPayload) => declareItem(submissionId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['title-submission', submissionId] });
      queryClient.invalidateQueries({ queryKey: ['title-submission-score-preview', submissionId] });
    },
  });
};

export const useUpdateTitleItem = (submissionId: string, itemId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: IUpdateItemPayload) => updateItem(submissionId, itemId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['title-submission', submissionId] });
      queryClient.invalidateQueries({ queryKey: ['title-submission-score-preview', submissionId] });
    },
  });
};

export const useDeleteTitleItem = (submissionId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (itemId: string) => deleteItem(submissionId, itemId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['title-submission', submissionId] });
      queryClient.invalidateQueries({ queryKey: ['title-submission-score-preview', submissionId] });
    },
  });
};
